import { EPopupGroupActions } from '~/src/components/ConnectDomruPopup/context/constants/actions';
import { InferValueTypes } from '~/src/store';

import * as actions from './actions';
import initialState, { TInitialState } from './initialState';

export type TAction = ReturnType<InferValueTypes<typeof actions>>

export const reducer = (state: TInitialState = initialState, action: TAction): TInitialState => {
    switch (action.type) {
        case EPopupGroupActions.SetView: {
            return {
                ...state,
                view: action.payload.view,
            };
        }
        case EPopupGroupActions.ToggleFilter: {
            const updatedFilters = state.productFilters.map(
                filter => filter.value === action.payload.filter ? { ...filter, checked: !filter.checked } : filter,
            );

            return {
                ...state,
                productFilters: [...updatedFilters],
            };
        }
        case EPopupGroupActions.SetResult: {
            return {
                ...state,
                result: action.payload.result,
            };
        }
        default:
            return { ...state };
    }
};
